import {
  Panel,
  PanelSection,
  EmptyState,
  EmptyStateTitle,
  EmptyStateDescription,
  EmptyStateActions,
  Box,
  Button,
} from '@customerio/pluma-components/react';

interface VerificationStatusApprovedProps {
  workspaceId: number | null;
}

export function VerificationStatusApproved({ workspaceId }: VerificationStatusApprovedProps) {
  return (
    <Panel>
      <PanelSection display="flex" justifyContent="center" alignItems="center" p="400">
        <EmptyState>
          <EmptyStateTitle icon="check-circle">Account verification approved</EmptyStateTitle>
          <EmptyStateDescription>Good news, you've been approved! Happy sending.</EmptyStateDescription>
          {workspaceId != null ? (
            <EmptyStateActions>
              <Box display="flex" gap="200" justifyContent="center">
                <Button href={`/workspaces/${workspaceId}/journeys/broadcasts`} icon="broadcast">
                  Send broadcast
                </Button>
                <Button href={`/workspaces/${workspaceId}/journeys/campaigns`} icon="campaigns">
                  Send email campaign
                </Button>
              </Box>
            </EmptyStateActions>
          ) : null}
        </EmptyState>
      </PanelSection>
    </Panel>
  );
}
